import { useTranslation } from 'react-i18next';

import HomeCard from './HomeCard';
import { useGroupTemperatureOrder } from '../../modules/organisation/hooks/useGroupStandardData';
import Table from '../Table';
import { equipmentNameLink, lastDataProcessed, temperature, utilisation } from './columns';
import useDeviceStatusFilter from '../../modules/equipment/hooks/useDeviceStatusFilter';
import useLocalisedColumns from '../../hooks/useLocalisedColumns';

const columns = [
  lastDataProcessed,
  equipmentNameLink,
  temperature,
  utilisation,
];

function HighestTemperatureEquipment() {
  const { t } = useTranslation();
  const groupTemperatureOrder = useGroupTemperatureOrder();
  const { filterAll } = useDeviceStatusFilter();
  const localisedColumns = useLocalisedColumns(columns);

  if(!groupTemperatureOrder) return null;

  const {_state_: {loading, error} = {}, items = []} = groupTemperatureOrder || {};
  return (
    <HomeCard
      header={t("user.Highest_Temperature_Equipment")}
      headerLink={{to: '/', text: t('home.all-equipment'), onClick: filterAll }}
      loading={loading}
      error={error}
    >
      <Table
        data={items}
        keyField="device_id"
        loading={loading}
        columns={localisedColumns}
        condensed
      />
    </HomeCard>
  );
}

export default HighestTemperatureEquipment;